export default __webpack_public_path__ + "static/media/772.0888007e.png";